import {
	DocumentTypeEnum,
	EntityTypesEnum,
	FormatTypeEnum,
	FormatTypeModifiersEnum, SaleStatusEnum
} from './default-constants'
import numeral from '../../static-vendors/numeral/numeral'
import {format, parseISO} from 'date-fns'
//import numeralLocalePtBr from "./numeral-locale-pt-br";
class Result {
	constructor({isSuccess, message, errorModel, data}) {
		this.isSuccess = isSuccess;
		this.message = message;
		this.errorModel = errorModel;
		this.data = data;
	}

}
class MaskTemplateItem {
	constructor({selector, defaultMask, options}) {
		this.selector = selector;
		this.defaultMask = defaultMask;
		this.options = options;
	}
}

class SnippetLoader {
	InitSnippet(snippetObject) {
	}
}

class UtilFunctions {
	constructor() {
		if (window.UtilFunctions) {
			return window.UtilFunctions;
		}
		window.UtilFunctions = this;
		$("document").ready(() => this.#init());
	}

	#init() {
		console.log("initing utilFunctions");
		this.#initializeMasks();
		this.#initializeLocales();
	}

	#initializeLocales() {
		numeral.register('locale', 'pt-BR', {
			delimiters: {
				thousands: '.',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			currency: {
				symbol: 'R$'
			}
		});
		numeral.locale('pt-BR');
	}

	/**
	 * Replaces or adds items from `arr2` into `arr1` in-place, based on a predicate key.
	 *
	 * If an item in `arr2` matches an item in `arr1` (as determined by the `predicate` key),
	 * it replaces the existing item in `arr1`. If no match is found, the item is appended.
	 *
	 * @template T
	 * @param {T[]} arr1 - The target array to be mutated (items will be replaced or added).
	 * @param {T[]} arr2 - The source array containing new or updated items.
	 * @param {(item: T) => string | number} predicate - A function that returns a unique key for each item.
	 *
	 * @example
	 * const arr1 = [{ id: 1, name: "Alice" }, { id: 2, name: "Bob" }];
	 * const arr2 = [{ id: 2, name: "Robert" }, { id: 3, name: "Charlie" }];
	 * replaceOrAddInPlace(arr1, arr2, item => item.id);
	 * // arr1 is now:
	 * // [
	 * //   { id: 1, name: "Alice" },
	 * //   { id: 2, name: "Robert" },
	 * //   { id: 3, name: "Charlie" }
	 * // ]
	 */
	replaceOrAddInPlace(arr1, arr2, predicate) {
		const keyIndexMap = new Map(arr1.map((item, index) => [predicate(item), index]));

		for (const item of arr2) {
			const key = predicate(item);
			if (keyIndexMap.has(key)) {
				const idx = keyIndexMap.get(key);
				arr1[idx] = item; // replace
			} else {
				keyIndexMap.set(key, arr1.length);
				arr1.push(item); // add
			}
		}
	}
	
	isFunction(value) {
		return value &&  typeof value === 'function';
	}
		
	validateDocument(documentNumber){
		let sanitizedInput = documentNumber.replace(/\D/g, '');
		if(sanitizedInput.length === 11){
			let isValid = this.isValidNationalId(sanitizedInput);
			
			return new Result({
				data: {
					type: DocumentTypeEnum.NATIONAL_ID,
					value: isValid
				},
				isSuccess:true
			});			
		}
		if(sanitizedInput.length === 14){
			let isValid = this.isValidRegisteredNumber(sanitizedInput);
			
			return new Result({
				data: {
					type: DocumentTypeEnum.REGISTERED_NUMBER,
					value: isValid
				},
				isSuccess:true
			});			
		}

		return new Result({
			isSuccess:false, 
			message: 'Documento não identificado'
		});
	}
	isValidNationalId (nationalId) {

		let sanitizeNumber = nationalId.replace(/\D+/g, '');

		// Arrays de multiplicadores para os dígitos verificadores do CPF
		let firstDigitMultipliers = [10, 9, 8, 7, 6, 5, 4, 3, 2];
		let secondDigitMultipliers = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

		// Cálculo do primeiro dígito verificador
		let firstVerifier = this.calculateDigitNationalId(sanitizeNumber, firstDigitMultipliers);
		if (firstVerifier !== parseInt(sanitizeNumber.charAt(9))){
			return false;
		}

		// Cálculo do segundo dígito verificador
		let secondVerifier = this.calculateDigitNationalId(sanitizeNumber, secondDigitMultipliers);
		return secondVerifier === parseInt(sanitizeNumber.charAt(10));
	}

	calculateDigitNationalId (nationalId, multipliers) {
		let sum = 0;

		// Aplica cada multiplicador ao dígito correspondente
		for (let i = 0; i < multipliers.length; i++) {
			sum += parseInt(nationalId.charAt(i)) * multipliers[i];
		}

		let remainder = (sum * 10) % 11;

		// Se o resto for 10 ou 11, o dígito verificador é 0
		return remainder === 10 || remainder === 11 ? 0 : remainder;
	}

	isValidRegisteredNumber (registeredNumber) {
		let sanitizeNumber = registeredNumber.replace(/\D+/g, '');

		// Arrays de multiplicadores para os dígitos verificadores do CNPJ
		let firstDigitMultipliers = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		let secondDigitMultipliers = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

		// Cálculo do primeiro dígito verificador
		let firstVerifier = this.calculateDigitRegisteredNumber(sanitizeNumber, firstDigitMultipliers);
		if (firstVerifier !== parseInt(sanitizeNumber.charAt(12))) return false;

		// Cálculo do segundo dígito verificador
		let secondVerifier = this.calculateDigitRegisteredNumber(sanitizeNumber, secondDigitMultipliers);
		return secondVerifier === parseInt(sanitizeNumber.charAt(13));
	}

	calculateDigitRegisteredNumber (registeredNumber, multipliers) {
		let sum = 0;

		// Aplica cada multiplicador ao dígito correspondente
		for (let i = 0; i < multipliers.length; i++) {
			sum += parseInt(registeredNumber.charAt(i)) * multipliers[i];
		}

		let remainder = sum % 11;

		// Se o resto for menor que 2, o dígito verificador é 0; caso contrário, é 11 - resto
		return remainder < 2 ? 0 : 11 - remainder;
	}


	setBillOrderNumber(control, billOrderNumber) {
		let saleIdentifier = billOrderNumber;

		for (let i = 0; i < saleIdentifier.length; i++) {
			let letter = saleIdentifier.charAt(i);
			control.append($(`<span class='billOrderNumberDigit'>${letter}</span>`))
		}

	}

	async sleep(time) {
		await new Promise(resolve => setTimeout(resolve, time));
	}

	#initializeMasks() {
		//let MoneyOpts = {
		//	reverse: true,
		//	maxlength: false,
//
		//};
		///**
		// * @type {MaskTemplateItem[]}
		// */
		//let masks = [
		//	new MaskTemplateItem({selector: '[data-input-type="currency"]', defaultMask: '#.##0,00', options: {reverse: true}}),
		//	new MaskTemplateItem({selector: '[data-input-type="numeric"]', defaultMask: '#.##0', options: {reverse: true}})
		//];
//
		//for (let mask of masks) {
		//	$(mask.selector).mask(mask.defaultMask, mask.options);
		//}
//
		//// Apply global mask 
		//$.applyDataMask();
	}

	truncateString = function (str, num) {
		if (!num) {
			num = 20;
		}
		if (str.length > num) {
			return str.slice(0, num) + "...";
		} else {
			return str;
		}
	}
	sanitizeDotnetDateOffset = function(input) {
		// Match the full fractional second part and truncate to 3 digits
		return input?.replace(/(\.\d{3})\d+/, '$1');
	}
	formatDateFromIso = function (value, formatType) {
		let parsedData = parseISO(value);

		if (!parsedData) {
			return new Result({isSuccess: false, message: 'Not valid ISO'});
		}

		switch (formatType) {
			case FormatTypeEnum.SHORT_DATE:
				return format(this.sanitizeDotnetDateOffset(parsedData), 'dd/MM');

			case 'datetime':
			case FormatTypeEnum.DATE_TIME:
				return format(this.sanitizeDotnetDateOffset(parsedData), 'dd/MM/yyyy HH:mm');

			case FormatTypeEnum.SHORT_DATE_TIME:
				return format(this.sanitizeDotnetDateOffset(parsedData), 'dd/MM HH:mm');

			default:
			case FormatTypeEnum.DATE:
				return format(this.sanitizeDotnetDateOffset(parsedData), 'dd/MM/yyyy');
		}

	}
	parse = function(param){
		switch (param.type) {
			case FormatTypeEnum.CURRENCY:
				return numeral(param.value).value();
			case FormatTypeEnum.INTEGER:
				return parseInt(param.value);
			case FormatTypeEnum.DATE_TIME:
				return parseISO(this.sanitizeDotnetDateOffset(param.value));
		}
	}
	format = function (param) {
		switch (param.type) {
			case FormatTypeEnum.CURRENCY:
				let currencyToken = '$';
				if((param.modifiers & FormatTypeModifiersEnum.NO_UNIT_SIGN) === FormatTypeModifiersEnum.NO_UNIT_SIGN){
					currencyToken = '';
				}
				
				//let digits = 
				
				if (param.digits !== undefined && param.digits !== null) {
					return numeral(param.value).format(`${currencyToken} 0,0.${''.padEnd(param.digits, '0')}`);
				} else {
					return numeral(param.value).format(`${currencyToken} 0,0.00`);
				}
			case 'double':
			case FormatTypeEnum.DECIMAL:
				if (numeral(param.value).format('0,0.00').toString() === 'NaN') {
					param.value = 0;
				}

				if (param.digits !== undefined && param.digits !== null) {
					return numeral(param.value).format('0,0.' + ''.padEnd(param.digits, '0'));
				} else {
					return numeral(param.value).format('0,0.00');
				}
				break;

			case 'long':
			case FormatTypeEnum.INTEGER:
				return numeral(param.value).format('0,0');
				break;

			case FormatTypeEnum.PERCENTAGE:
				let percentageToken = '%';
				if((param.modifiers & FormatTypeModifiersEnum.NO_UNIT_SIGN) === FormatTypeModifiersEnum.NO_UNIT_SIGN){
					percentageToken = '';
				}
				return numeral(param.value).format(`0,0.0${percentageToken}`);
				break;

			case FormatTypeEnum.SHORT_DATE:
				return format(this.sanitizeDotnetDateOffset(param.value), 'dd/MM');
				break;

			case 'datetime':
			case FormatTypeEnum.DATE_TIME:
				return format(this.sanitizeDotnetDateOffset(param.value), 'dd/MM/yyyy HH:mm');
				break;

			case FormatTypeEnum.SHORT_DATE_TIME:
				return format(this.sanitizeDotnetDateOffset(param.value), 'dd/MM HH:mm');
				break;

			case FormatTypeEnum.DATE:
				return format(this.sanitizeDotnetDateOffset(param.value), 'dd/MM/yyyy');
				break;

			default:
				return param.value;
		}
	};

	pluralize(itemCount, textIfSingular, textIfPlural) {
		return itemCount > 1 ? textIfPlural : textIfSingular;
	}

	/**
	 *
	 * @param component : jquery
	 * @param formatType : string
	 */
	applyMask(component, formatType) {
		switch (formatType) {
			case FormatTypeEnum.CURRENCY:
				$(component).mask("#.##0,00", {reverse: true});
		}
	}

	getQueryParametersFromObject(instance) {
		let parameters = [];
		for(let objectName in instance){
			if(instance[objectName]){
				parameters.push(`${objectName}=${instance[objectName]}`);				
			}
		}
		
		return `?${parameters.join('&')}`;
	}

	isSuccessStatus(status){
		return status >= 200 && status < 300;
	}
	
}

/*
* var Util = function () {
    var _instance = {};
    var _modalStack = [];
    var _refreshTimeout;
    var _displayTimeout;
    var _displayTimeoutDuration;
    var _lastProductTourId;
    var _lastProductTourStepId;
    var _lastProductTourStepOrder = 0;
    var _pageType;
    
    var init = function () {
        _instance.isDeveloper = Util.parseBoolean($('#isDeveloper').val());
    };

    var generateQueryStringParam = function (name, value) {
        if (value) {
            return '&' + name + '=' + encodeURIComponent(value);
        }

        return '';
    };

    var generateQueryStringFromObject = function (obj) {
        if (!obj) {
            return '';
        }
        if (Object.keys(obj).length === 0) {
            return '';
        }
        let query = '';
        for (let i = 0; i < Object.keys(obj).length; i++) {
            let currentKey = Object.keys(obj)[i];
            let currentValue = Object.values(obj)[i];
            if (currentKey !== '' && currentKey !== undefined && currentKey !== null && currentValue !== '' && currentValue !== undefined && currentValue !== null) {
                if (Object.prototype.toString.call(currentValue) === '[object Array]') { 
                    currentValue.forEach(value => {
                        query += "&" + currentKey;
                        query += "=" + value;        
                    });                         
                } else {
                    query += "&" + currentKey;
                    query += "=" + currentValue;
                }                
            }
        }
        if (query === '') {
            return query;
        }
        query = '?' + query.substring(1);
        return query;
    };
    
    var readQueryString = function (name) {
        let urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    };

    var pushQueryString = function (name, value) {
        let params = new URLSearchParams(window.location.search);
        params.set(name, value);

        window.history.pushState(null, null, window.location.pathname + '?' + params.toString());
    };

    var deleteQueryString = function (name) {
        let params = new URLSearchParams(window.location.search);
        params.delete(name);

        window.history.pushState(null, null, window.location.pathname + '?' + params.toString());
    };

    var setElementHtml = function (obj, element, index, value) {
        var e = $(obj).find(element)[index];
        $(e).html(value);
    };

    var setElementVal = function (obj, element, index, value) {
        var e = $(obj).find(element)[index];
        $(e).val(value);
    };
    
    var cloneElement = function (element) {
        let clone = $(element).clone();
        
        clone.removeClass('d-none');
        clone.attr('id', '');
            
        $(element).remove();
        
        return clone;
    };

    var parseString = function (string) {
        if (string === null || string === undefined || string.length === 0)
        {
            return '';
        }
        
        return string.toString();
    };

    var parseNumber = function (number) {
        if (number === null || number === undefined || number.toString().length === 0)
        {
            return;
        }

        if (typeof (number) === 'boolean') {
            return number ? 1 : 0;
        }
        
        return numeral(number).value();
    };

    var parseDecimal = function (number, currencyFormat) {
        if (number === null || number === undefined || number.toString().length === 0)
        {
            return;
        }

        if (currencyFormat) {
            switch (currencyFormat) {
                case 'C2':
                    let formatedNumber = number.replace('R$', '').replace('.', '').replace(',', '.');
                    number = formatedNumber.trim();
                    break;
            }
        }

        return parseFloat(number);
    };

    var parseBoolean = function (bool) {
        if (bool === null || bool === undefined || bool.toString().length === 0)
        {
            return;
        }
        
        let boolStr = bool.toString();

        return boolStr === '1' || boolStr === 'true' || boolStr === 'True';
    };

    var parseDate = function (date) {
        if (date === null || date === undefined || date.toString().length === 0)
        {
            return;
        }
        
        return moment(date, 'L');
    };

    var parseDateTime = function (datetime) {
        if (datetime === null || datetime === undefined || datetime.toString().length === 0)
        {
            return;
        }

        return moment(datetime, 'L LTS');
    };
    
    var getCurrentUtcDate = function () {
        return moment.utc(moment().format('YYYY-MM-DD'));
    };
    
    var getDateDiff = function (datetime1, datetime2) {
        
        if (typeof (datetime1) !== 'object' || typeof (datetime2) !== 'object') {
            return;
        }
        
        let d1 = moment(datetime1);
        let d2 = moment(datetime2)
        return d1.diff(d2, 'days')
    }

    var textAreaCountUpdate = function (obj) {
        var prev = $(obj).prevAll('span').last();

        if (prev.hasClass('textarea-count')) {
            var max = $(obj).attr('maxlength');
            prev.html(max - $(obj).val().length);
        }
    };

    var validateForm = function (f) {
        let validation = {
            submitHandler: function (form) {
                var noLoading = $(form).attr('no-loading');
                var asyncSubmit = $(form).attr('async-submit');
                var isAsync = (typeof asyncSubmit !== typeof undefined && asyncSubmit !== false);

                if (!(typeof noLoading !== typeof undefined && noLoading !== false)) {
                    if (!isAsync) {
                        Loading.show(true);
                    }
                }

                if (isAsync) {
                    try {
                        eval(asyncSubmit);
                    }
                    catch (e) {
                        Sentry.captureException(e);
                        Message.show('error', 'Error', e.toString());
                    }
                }
                else {
                    form.submit();
                }
            },
            
            rules: {
                
            }
        };

        let formRadios = $(f).find('input[type="radio"][required]');
        formRadios.each(function() {
            let radio = $(this).attr('name');
            validation.rules[radio] = {};
            validation.rules[radio].required = true;
        });
        
        return $(f).validate(validation);
    };

    var select = function (obj, data) {
        var clear = $(obj).attr('no-clear');
        var allowClear = !(typeof clear !== typeof undefined && clear !== false);

        let options = {
            language: "pt-BR",
            allowClear: allowClear,
        };
        
        if (data)
        {
            options.data = data;
            options.escapeMarkup = function(markup) {
                return markup;
            };

            options.templateResult = function(data) {
                return data.html;
            };

            options.templateSelection = function(data) {
                return data.text;
            };
        }
        
        $(obj).select2(options).on('select2:unselecting', function () {
            $(this).data('unselecting', true);
        }).on('select2:opening', function (e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });
    };
    
    var dateMask = function(obj) {
        $(obj).inputmask({
            alias: 'datetime',
            inputFormat: 'dd/MM/yyyy',
            displayFormat: 'dd/MM/yyyy',
            outputFormat: 'dd/MM/yyyy',
            autoUnmask: true
        });

        $(obj).datetimepicker({ format: 'dd/mm/yyyy', minView: 2, language: 'pt-BR', autoclose: true, todayBtn: true, todayHighlight: true, forceParse: true });
    };

    var datetimeMask = function(obj) {
        $(obj).inputmask({
            alias: 'datetime',
            inputFormat: 'dd/MM/yyyy HH:MM',
            displayFormat: 'dd/MM/yyyy HH:MM',
            outputFormat: 'dd/MM/yyyy HH:MM',
            autoUnmask: true,
            onUnMask: function(maskedValue, unmaskedValue) {
                if (maskedValue !== null && maskedValue !== undefined && maskedValue.length > 0)
                {
                    return maskedValue + ':00';
                } else {
                    return null;
                }
            }
        });

        $(obj).datetimepicker({ format: 'dd/mm/yyyy hh:ii:ss', language: 'pt-BR', autoclose: true, todayBtn: true, todayHighlight: true, forceParse: true });
    };

    var monthMask = function(obj, initialDate) {
        $(obj).datetimepicker({ format: 'MM / yyyy', minView: 3, maxView: 4, startView: 3, initialDate: initialDate, language: 'pt-BR' });
    };

    var refreshPageRecurrently = function (pageType) {
        var timeout = 60000;
        _pageType = pageType;
        
        if (_refreshTimeout) {
            clearInterval(_refreshTimeout);
        }

        switch (pageType) {
            case RefreshPageTypeEnum.DASHBOARD:
                timeout = 120000;

                startDisplayTimer(timeout / 1000, $('#dashboardCountdown'));
                $('#dashboardControlIcon').html('<i class="fal fa-pause">');
                $('#dashboardControlText').html('parar');
                $('#dashboardControl').attr('onclick', 'Util.stopRefreshPageRecurrently(); return false;');
                break;

            case RefreshPageTypeEnum.WORKFLOW:
                timeout = 120000;
                break;

            case RefreshPageTypeEnum.BILLING:
                timeout = 5000;
                break;
        }

        _refreshTimeout = setInterval(function () {
            if (_instance.refreshCallback != null) {
                _instance.refreshCallback();
                if (_pageType === RefreshPageTypeEnum.DASHBOARD) {
                    startDisplayTimer(_displayTimeoutDuration, $('#dashboardCountdown'));    
                }
            } else {
                Util.refreshPage();
            }
            
        }, timeout);
    };
    
    var setRefreshCallback = function (callback) {
        _instance.refreshCallback = callback;
    };

    var stopRefreshPageRecurrently = function () {
        clearInterval(_refreshTimeout);
        if (_displayTimeout !== null) {
            clearInterval(_displayTimeout);
            $('#dashboardControlIcon').html('<i class="fal fa-play">');
            $('#dashboardControlText').html('iniciar');
            $('#dashboardControl').attr('onclick', 'Util.refreshPageRecurrently(RefreshPageTypeEnum.DASHBOARD); return false;');

            $('#dashboardProgressBar').css('transition-duration', '0s');
            $('#dashboardProgressBar').css('width', '0%');
            $('#dashboardProgressBar').attr('aria-valuenow', '0');
            $('#dashboardCountdown').html('--:--');
        }
    };

    var uuidv4 = function() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    };
    
    var showModal = function (modal) {
        _modalStack.push(modal);

        hideSupport();
        hideChat();
        
        if (_modalStack.length > 1) {
            let last = _modalStack[_modalStack.length - 2];
            $(last).modal('hide');
        }
        
        $('body').css('overflowY', 'hidden');
        $(modal).appendTo("#modalContent");
        let newModal = $(modal);

        try {
            newModal.on('shown.bs.modal', function () {
                $(document).off('focusin.modal');
                newModal.find('.modal-body').scrollTop(0);
            });
            
            newModal.modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        } catch (e) {
            Sentry.captureException(e);
        }
    };

    var closeModal = function (clear) {
        $(_modalStack.pop()).modal('hide');

        if (clear === true)
        {
            _modalStack = [];
            $('body').css('overflowY', 'auto');

            showSupport();
            return;
        }
        
        if (_modalStack.length > 0)
        {
            let last = _modalStack[_modalStack.length - 1];
            $(last).modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        } 
        else
        {
            $('body').css('overflowY', 'auto');
            showSupport();
        }
    };
    
    var setSentryUser = function (data) {
        Sentry.setUser({"id": data.userId + ' - ' + data.userName , "email": data.fleetManagerName });
    };
    
    var setHeapUniqueIdentifier = function (data) {
        heap.identify(data.userId);
        heap.addUserProperties({'Name': data.userName, 'FleetManagerName': data.fleetManagerName});
    }

    var hashCode = function (str) {
        var hash = 0;
        if (str.length == 0) return hash;
        for (i = 0; i < str.length; i++) {
            char = str.charCodeAt(i);
            hash = ((hash<<5)-hash)+char;
            hash = hash & hash; // Convert to 32bit integer
        }
        
        return hash;
    };

    var enableInput = function (input, enabled) {
        let i = $(input);
        
        if (enabled) {
            i.removeAttr('readonly');
            i.removeAttr('disabled');
            let dtp = i.data("DateTimePicker");
            if (dtp) {
                dtp.enable();
            }
        } else {
            i.attr('readonly', 'readonly');
            i.attr('disabled', 'disabled');
            let dtp = i.data("DateTimePicker");
            if (dtp) {
                dtp.disable();
            }
        }
    };
    
    var refreshPage = function () {
        window.location.href += '';
    };
    
    var log = function (data) {
        if (_instance.isDeveloper) {
            console.log(data);
        }
    };

    var round2 = function (num) {
        return Math.round((num + Number.EPSILON) * 100) / 100
    };

    var round4 = function (num) {
        return Math.round((num + Number.EPSILON) * 10000) / 10000
    };

    var trunc2 = function (num) {
        return Math.trunc((num + Number.EPSILON) * 100) / 100
    };

    var trunc4 = function (num) {
        return Math.trunc((num + Number.EPSILON) * 10000) / 10000
    };

    var trunc = function (num, places) {
        let pow = Math.pow(10, places);
        return Math.trunc(num * pow) / pow;
    };

    var handleResultError = function (exception, titleAlert) {
        if (exception) {
            if (exception.code === ResultCodeEnum.DUPLICATE_POST) {
                Message.show('info', '', 'Evite clicar duas vezes.<br>Isto pode gerar problemas no sistema.');
                return;
            }

            if (exception.code === ResultCodeEnum.UNKNOWN) {
                Sentry.captureException(exception);
            }

            var message = 'Por favor, verifique os erros abaixo:<br><br><div class="error-message-container">' + exception.message + '</div>';

            Message.alert({
                type: 'error',
                title: titleAlert || 'Erro',
                message: message,
            });
        }
    };

    var showSupport = function () {
        try {
            FreshworksWidget('show');
        } catch (e) {
            Sentry.captureException(e);
        }
    };

    var hideSupport = function () {
        try {
            FreshworksWidget('hide');
        } catch (e) {
            Sentry.captureException(e);
        }
    };
    
    var openSupport = function () {
        try {
            FreshworksWidget('open');
        } catch (e) {
            Sentry.captureException(e);
        }
    };
    
    var removeStringSpaces = function (string){
        if(typeof (string) !== 'string'){
            return '';
        }
        return string.replace(/\s+/g, '');
    };

    var configureEditableContents = function (settings) {
        if (!settings) {
            return;
        }

        if (settings.length <= 0) {
            return;
        }

        settings.forEach((setting) => {
            if (!setting.fields) {
                return;
            }

            if (setting.fields <= 0) {
                return;
            }
            
            setting.fields.forEach((field) => {
                let selector = '#' + field.elementId;

                let jsonSetting = {
                    url: setting.url,
                    elementOriginId: field.elementId,
                    contextId: setting.contextId,
                    context: setting.context,
                    fieldName: field.fieldName,
                    fieldType: field.fieldType,
                    labelName: field.labelName,
                    mask: field.mask,
                    isMandatory: field.isMandatory
                };

                $(selector).attr('editable-content', '');
                $(selector).attr("data-setting", JSON.stringify(jsonSetting));
                
                if (field.afterEditingFunction !== undefined && typeof field.afterEditingFunction === 'function')
                {
                    $(selector).off('after.editing').on('after.editing', field.afterEditingFunction);
                }                
                
                let previousElement = null;

                let previousElements = $(selector).prevAll();

                for (let i = 0; i < previousElements.length; i++) {
                    let element = previousElements[i];

                    if (element.tagName === 'LABEL') {
                        previousElement = element;
                        break;
                    }

                    if (element.tagName === 'SPAN') {
                        previousElement = element;
                        break;
                    }
                }

                if (previousElement !== null) {
                    if (Array.from(previousElement.children).filter(el => el.tagName === 'I').length === 0) {
                        let pencilElement = document.createElement('i');
                        pencilElement.classList.add('fal', 'fa-pencil-alt', 'inline-edit-icon');
                        pencilElement.style.paddingLeft = '6px';
                        previousElement.append(pencilElement);
                    }

                    previousElement.setAttribute('data-toggle', 'tooltip');
                    previousElement.setAttribute('title', 'Clique para editar');
                    $(previousElement).tooltip();
                    
                    previousElement.setAttribute('editable-content', '');
                    previousElement.setAttribute("data-setting", JSON.stringify(jsonSetting));
                }
            });
        });
        
        activateEditableContents();
    };

    var activateEditableContents = function () {
        $("[editable-content]").prop("onclick", null).off("click");
        
        $("[editable-content]").on("click", function (e) {
            let setting = null;

            if (e.currentTarget.dataset.setting) {
                setting = $.parseJSON(e.currentTarget.dataset.setting);
            }

            if (setting === '' || setting === null || typeof (setting) === 'undefined') {
                Util.log('Attribute editable-content must contain JSON value for data-setting');
                return;
            }
            
            let contextId = setting.contextId;
            let context = setting.context;
            let fieldName = setting.fieldName;
            let fieldType = setting.fieldType;
            let labelName = setting.labelName;

            if (contextId === '' || contextId === null || typeof (contextId) === 'undefined') {
                Util.log('Property contextId of data-setting must contain a value');
                return;
            }

            if (context === '' || context === null || typeof (context) === 'undefined') {
                Util.log('Property context of data-setting must contain a value');
                return;
            }

            if (fieldName === '' || fieldName === null || typeof (fieldName) === 'undefined') {
                Util.log('Property fieldName of data-setting must contain a value');
                return;
            }

            if (fieldType === '' || fieldType === null || typeof (fieldType) === 'undefined') {
                Util.log('Property fieldType of data-setting must contain a value');
                return;
            }

            let data = {
                url: setting.url,
                elementOriginId: setting.elementOriginId,
                contextId: contextId,
                contextName: context,
                fieldName: fieldName,
                fieldType: fieldType,
                labelName: labelName,
                mask: setting.mask,
                isMandatory: setting.isMandatory
            }

            showEditableContentPopup(data);
        });
    };

    var showEditableContentPopup = function (data) {
        let popup = $('#divEditableContentPopup').clone().removeClass('d-none');
        let form = popup.find('form');

        let colSpan = getEditableContentColSpan(data);

        $.dialog({
            title: "Editar",
            content: popup,
            columnClass: colSpan,
            onOpenBefore: function () {
                let dialog = this;
                let btnSave = dialog.$content.find('#btnEditableContentSave');
                let btnCancel = dialog.$content.find('#btnEditableContentCancel');

                Util.validateForm(form);

                let elements = getEditableContentElementsByDialog(dialog);

                configureEditableContentElements(data, elements);

                $(form).find(":input").inputmask();

                btnCancel.on('click', function () {
                    dialog.close();
                });

                btnSave.on('click', function () {
                    if (!form.valid()) return false;

                    let fieldValue = null;

                    switch (data.fieldType) {
                        case EditableContentFieldTypeEnum.TEXT_AREA:
                            fieldValue = elements.txtEditableTextArea.val();
                            break;
                        case EditableContentFieldTypeEnum.TEXT:
                        case EditableContentFieldTypeEnum.INTEGER:
                            fieldValue = elements.txtEditableText.val();
                            break;
                        case EditableContentFieldTypeEnum.DATE_TIME:
                            fieldValue = Util.parseDateTime(elements.txtEditableDatetime.val());
                            break;
                        case EditableContentFieldTypeEnum.DATE:
                            fieldValue = Util.parseDate(elements.txtEditableDate.val());
                            break;
                        case EditableContentFieldTypeEnum.CURRENCY:
                            fieldValue = Util.parseDecimal(elements.txtEditableCurrency.val());
                            break;
                        case EditableContentFieldTypeEnum.YES_NO:
                            fieldValue = elements.optEditableYes.is(':checked') === true ? "TRUE" : "FALSE";
                            let isYesChecked = elements.optEditableYes.is(':checked') === true;
                            let isNoChecked = elements.optEditableNo.is(':checked') === true;

                            if (!isYesChecked && !isNoChecked) {
                                fieldValue = null;
                            }
                            break;
                        case EditableContentFieldTypeEnum.DIRECTION:
                            fieldValue = elements.txtEditableAddress.val();

                            if (fieldValue !== null && typeof (fieldValue) !== 'undefined' && fieldValue.length > 0 && fieldValue !== '') {
                                fieldValue = {
                                    address: elements.txtEditableAddress.val(),
                                    state: elements.ddlEditableState.val() > 0 ? elements.ddlEditableState.select2('data')[0].text : null,
                                    city: elements.ddlEditableCity.val() > 0 ? elements.ddlEditableCity.select2('data')[0].text : null,
                                    county: elements.txtEditableCounty.val(),
                                    country: 'BR'
                                };
                            }
                            break;
                        case EditableContentFieldTypeEnum.CONTRACT_ITEM_CLAIM_REQUEST_REASON_CLASS:
                        case EditableContentFieldTypeEnum.GOVERNMENTAL_ENTITY:
                        case EditableContentFieldTypeEnum.FINE:
                        case EditableContentFieldTypeEnum.INSURANCE_ACCOUNTABILITY_TYPE:
                        case EditableContentFieldTypeEnum.INSURANCE_POLICY:
                        case EditableContentFieldTypeEnum.REASON_CLASS_CAUSES:
                            fieldValue = elements.ddlEditableContent.val();
                            break;
                    }

                    if (data.isMandatory && (fieldValue === '' || fieldValue === null || typeof (fieldValue) === 'undefined' || fieldValue <= 0)) {
                        Message.alert({
                            type: 'error',
                            title: 'Erro ao salvar',
                            message: 'Preencha algum valor para salvar',
                        });

                        return;
                    }

                    data.fieldValue = fieldValue;

                    let postData = {
                        contextId: data.contextId,
                        contextName: data.contextName,
                        fieldName: data.fieldName,
                        fieldType: data.fieldType,
                        fieldValue: null,
                        dateTimeFieldValue: null,
                        direction: null
                    };

                    if (data.fieldValue !== '' && data.fieldValue != null && typeof (data.fieldValue) !== 'undefined' && data.fieldValue) {
                        postData.fieldValue = data.fieldValue.toString();
                    }

                    if (data.fieldType === EditableContentFieldTypeEnum.DIRECTION) {
                        postData.direction = fieldValue;
                        postData.fieldValue = null;
                    }

                    if (data.fieldType === EditableContentFieldTypeEnum.DATE_TIME || data.fieldType === EditableContentFieldTypeEnum.DATE) {
                        postData.dateTimeFieldValue = fieldValue;
                        postData.fieldValue = null;
                    }
                    
                    AsyncRequest.putData({
                        toastr: false,
                        title: 'Editar',
                        url: data.url,
                        data: postData
                    }).then(function (result) {
                        $('#' + data.elementOriginId).html(result.data.displayText).trigger('after.editing');
                        
                        let title = 'Editar ';
                        if (data.labelName) {
                            title += data.labelName.toLowerCase();
                        }

                        Message.show('success', title, 'Informação atualizada com sucesso!');
                        
                        dialog.close();
                    }).catch(function (e) {
                        Util.handleResultError(e, 'Erro ao editar');
                    });
                });
            }
        });
    };

    var getEditableContentColSpan = function (data) {
        let colSpan = 'col-9';

        switch (data.fieldType) {
            case EditableContentFieldTypeEnum.TEXT:
            case EditableContentFieldTypeEnum.CURRENCY:
            case EditableContentFieldTypeEnum.DATE_TIME:
            case EditableContentFieldTypeEnum.DATE:
            case EditableContentFieldTypeEnum.INTEGER:
            case EditableContentFieldTypeEnum.YES_NO:
            case EditableContentFieldTypeEnum.CONTRACT_ITEM_CLAIM_REQUEST_REASON_CLASS:
            case EditableContentFieldTypeEnum.INSURANCE_ACCOUNTABILITY_TYPE:
            case EditableContentFieldTypeEnum.INSURANCE_POLICY:
            case EditableContentFieldTypeEnum.GOVERNMENTAL_ENTITY:
            case EditableContentFieldTypeEnum.FINE:
            case EditableContentFieldTypeEnum.REASON_CLASS_CAUSES:
                colSpan = 'col-6';
                break;
            case EditableContentFieldTypeEnum.DIRECTION:
                colSpan = 'col-12';
                break;
        }

        return colSpan;
    };

    var getEditableContentElementsByDialog = function (dialog) {
        let data = {
            lblEditableLabel: dialog.$content.find('#lblEditableLabel'),
            txtEditableTextArea: dialog.$content.find('#txtEditableTextArea'),
            txtEditableText: dialog.$content.find('#txtEditableText'),
            divEditableCurrency: dialog.$content.find('#divEditableCurrency'),
            txtEditableCurrency: dialog.$content.find('#txtEditableCurrency'),
            divEditableDatetime: dialog.$content.find('#divEditableDatetime'),
            divEditableDatetime: dialog.$content.find('#divEditableDatetime'),
            txtEditableDatetime: dialog.$content.find('#txtEditableDatetime'),
            divEditableDate: dialog.$content.find('#divEditableDate'),
            txtEditableDate: dialog.$content.find('#txtEditableDate'),
            ddlEditableContent: dialog.$content.find('#ddlEditableContent'),
            divEditableYesNo: dialog.$content.find('#divEditableYesNo'),
            optEditableYes: dialog.$content.find('#optEditableYes'),
            optEditableNo: dialog.$content.find('#optEditableNo'),
            divEditableDirection: dialog.$content.find('#divEditableDirection'),
            ddlEditableState: dialog.$content.find('#ddlEditableState'),
            ddlEditableCity: dialog.$content.find('#ddlEditableCity'),
            txtEditableCounty: dialog.$content.find('#txtEditableCounty'),
            txtEditableAddress: dialog.$content.find('#txtEditableAddress')
        }

        return data;
    };

    var configureEditableContentElements = function (data, elements) {
        if (data.labelName) {
            elements.lblEditableLabel.html(data.labelName + ':');
        } else {
            elements.lblEditableLabel.html('');
        }

        var elementOriginValue = $('#' + data.elementOriginId).html();
        let hasOriginValue = elementOriginValue !== '---' && elementOriginValue !== null && typeof (elementOriginValue) !== 'undefined' && elementOriginValue.length > 0 && elementOriginValue !== '';

        switch (data.fieldType) {
            case EditableContentFieldTypeEnum.TEXT_AREA:
                if (hasOriginValue) {
                    elements.txtEditableTextArea.val(elementOriginValue);
                }
                elements.txtEditableTextArea.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.TEXT:
            case EditableContentFieldTypeEnum.INTEGER:
                if (hasOriginValue) {
                    elements.txtEditableText.val(elementOriginValue);
                }
                elements.txtEditableText.removeClass('d-none');

                if (data.mask) {
                    elements.txtEditableText.attr('data-inputmask', data.mask);
                }
                break;
            case EditableContentFieldTypeEnum.CURRENCY:
                if (hasOriginValue) {
                    elements.txtEditableCurrency.val(elementOriginValue);
                }
                elements.divEditableCurrency.removeClass('d-none');
                elements.txtEditableCurrency.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.DATE_TIME:
                if (hasOriginValue) {
                    elements.txtEditableDatetime.val(elementOriginValue);
                }
                elements.divEditableDatetime.removeClass('d-none');
                elements.txtEditableDatetime.removeClass('d-none');
                Util.datetimeMask('.form-datetime');
                break;
            case EditableContentFieldTypeEnum.DATE:
                if (hasOriginValue) {
                    elements.txtEditableDate.val(elementOriginValue);
                }
                elements.divEditableDate.removeClass('d-none');
                elements.txtEditableDate.removeClass('d-none');
                Util.dateMask('.form-date');
                break;
            case EditableContentFieldTypeEnum.YES_NO:
                if (hasOriginValue) {
                    if (elementOriginValue.toUpperCase() === 'SIM') {
                        elements.optEditableYes.prop('checked', true);
                    } else {
                        elements.optEditableNo.prop('checked', true);
                    }
                }

                elements.optEditableYes.on('change', function () {
                    elements.optEditableNo.prop('checked', false);
                });

                elements.optEditableNo.on('change', function () {
                    elements.optEditableYes.prop('checked', false);
                });

                elements.divEditableYesNo.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.DIRECTION:
                Util.select(elements.ddlEditableState);
                Util.select(elements.ddlEditableCity);
                elements.ddlEditableState.on('change', function () {
                    let stateId = $(this).val();
                    AsyncRequest.getDataAndFill(
                        {
                            select: elements.ddlEditableCity,
                            id: 'cityId',
                            text: 'name'
                        },
                        {
                            url: '/component/direction/state/' + stateId + '/city'
                        }
                    );
                });
                elements.divEditableDirection.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.GOVERNMENTAL_ENTITY:
                UtilSelect.configureGovernmentalProduct(elements.ddlEditableContent);
                elements.ddlEditableContent.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.CONTRACT_ITEM_CLAIM_REQUEST_REASON_CLASS:
                UtilSelect.configureContractItemRequestReasonClass(elements.ddlEditableContent, ContractItemRequestReasonEnum.CLAIM);
                elements.ddlEditableContent.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.FINE:
                UtilSelect.configureFine(elements.ddlEditableContent);
                elements.ddlEditableContent.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.REASON_CLASS_CAUSES:
                AsyncRequest.getData({
                    loading: false,
                    url: `/component/contract/item/request/${data.contextId}/reason-class`
                })
                .then(function (result) {
                    UtilSelect.configureContractItemRequestReasonClassCauses(result.data.contractItemRequestReasonClassId, null, elements.ddlEditableContent);
                    elements.ddlEditableContent.removeClass('d-none');
                });
                break;
            case EditableContentFieldTypeEnum.INSURANCE_ACCOUNTABILITY_TYPE:
                UtilSelect.configureInsuranceAccountabilityType(elements.ddlEditableContent);
                elements.ddlEditableContent.removeClass('d-none');
                break;
            case EditableContentFieldTypeEnum.INSURANCE_POLICY:
                UtilSelect.configureClaimInsurancePolicies(null, null, elements.ddlEditableContent, data.contextId);
                elements.ddlEditableContent.removeClass('d-none');
                break;
        }
    };

    var showChat = function () {
        try {
            if (window.fcWidget && window.fcWidget.isOpen() != true) {
                $('#fc_frame').show();
                window.fcWidget.open();
            }
        } catch (e) { }
    };

    var hideChat = function () {
        try {
            if (window.fcWidget && window.fcWidget.isOpen() == true) {
                window.fcWidget.close();
            }
        } catch (e) { }
    };

    var showCalendly = function () {
        hideSupport();
        hideChat();
        $('body').removeClass('aside-menu-show');
        Calendly.initPopupWidget(
            {
                url: 'https://calendly.com/blue-fleet-jaqueline/tira-duvidas',
                prefill: {
                    name: $('#txtLoggedUserName').val(),
                    email: $('#txtLoggedUserEmail').val(),
                }  
            });
    };

    var addModalContent = function(url, div) {
        $.ajax({
            async: false,
            url: url,
            success: function (data) {
                $(div).html(data);
            }
        });
    };
    
    var removeElementValueWhiteSpaces = function (element) {
        if (typeof(element) !== 'object') {
            return;
        }
        element.value = Util.removeStringSpaces(element.value);
    };
    
    var showProductTour = function (origin) {
        let url = window.location.pathname;
        let hasProductTour = false;

        AsyncRequest.getData({
            toastr: false,
            loading: false,
            url: '/component/product-tour/?origin=' + encodeURIComponent(origin) + '&url=' + encodeURIComponent(url)
        }).then(function (stepsResult) {
            if (stepsResult.data.productTourId > 0) {
                hasProductTour = true;
                addProductTourButton();
            }
            
            configureProductTour(stepsResult.data);
            
            if (!hasProductTour) {
                AsyncRequest.getData({
                    toastr: false,
                    loading: false,
                    url: '/component/product-tour/check?url=' + encodeURIComponent(url)
                }).then(function (result) {
                    if (result.data.hasProductTour) {
                        addProductTourButton();
                    }
                }).catch(function (e) {
                    Util.handleResultError(e);
                });
            }
            
        }).catch(function (e) {
            Util.handleResultError(e);
        });
    };
    
    var addProductTourButton = function () {
        if (document.querySelector('.breadcrumb-float-right') === null) {
            $('.breadcrumb').append('<div class="breadcrumb-float-right"></div>');
        }
        
        let divProductTour = $('#divProductTour').removeClass('d-none').addClass('d-inline-flex');
        $('.breadcrumb-float-right').find('#divProductTour').remove();
        let breadcrumbContent = $('.breadcrumb-float-right').html();
        
        $('.breadcrumb-float-right').empty().append(divProductTour).append(breadcrumbContent);
    };
    
    var showProductTourById = function (productTourId) {
        AsyncRequest.getData({
            toastr: false,
            loading: false,
            url: '/component/product-tour/' + productTourId
        }).then(function (stepsResult) {
            configureProductTour(stepsResult.data);
        }).catch(function (e) {
            Util.handleResultError(e);
        });
    };
    
    var configureProductTour = function (data) {
        if (!data.productTourId > 0) {
            return;
        }

        _lastProductTourId = data.productTourId;

        let showProgress = data.steps.length > 1;

        let options = {
            showBullets: false,
            showProgress: showProgress,
            doneLabel: 'Fechar',
            skipLabel: 'x',
            prevLabel: 'Anterior',
            nextLabel: 'Próximo',
            disableInteraction: true,
            exitOnOverlayClick: false,
            overlayOpacity: 0.6,
            steps: []
        };

        for (let x in data.steps) {
            let element = null;

            if (data.steps[x].element.substring(0, 2) === '//') {
                var headings = document.evaluate(data.steps[x].element, document, null, XPathResult.ANY_TYPE, null );
                element = headings.iterateNext();
            }
            else {
                if (data.steps[x].element !== '') {
                    element = document.querySelector(data.steps[x].element);

                    if (element === null) {
                        continue;
                    }
                }
            }

            $(element).attr('product-tour-step-id', data.steps[x].stepId);
            $(element).attr('product-tour-step-order', data.steps[x].stepOrder);

            options.steps.push({
                element: element,
                title: data.steps[x].title,
                intro: data.steps[x].intro,
                position: data.steps[x].position
            });
        }

        if (options.steps.length === 0) {
            return;
        }

        _lastProductTourStepId = data.steps[0].stepId;
        _lastProductTourStepOrder = 0;

        introJs()
            .setOptions(options)
            .onchange(async (targetElement) => {
                let order = Util.parseNumber($(targetElement).attr('product-tour-step-order'));
                if (order > _lastProductTourStepOrder) {
                    _lastProductTourStepId = Util.parseNumber($(targetElement).attr('product-tour-step-id'));
                    _lastProductTourStepOrder = order;
                }
            })
            // .onbeforechange(async (targetElement) => {
            //     return new Promise((resolve) => {
            //         if ($(targetElement).attr('id') === 'divNavigationDropdown') {
            //             console.log('Performing I/O...');
            //             setTimeout(function() {
            //                 console.log('txtNavigationFilter');
            //                 $('#navbarDropdownMenuLink').dropdown("toggle");
            //                 resolve();
            //             }, 500);
            //         } else {
            //             resolve();
            //         }
            //     });
            // })
            .onbeforeexit(async () => {
                return new Promise((resolve) => {
                    AsyncRequest.postData({
                        toastr: false,
                        url: '/component/product-tour/' + _lastProductTourId + '/done',
                        data: {
                            stepId: _lastProductTourStepId
                        }
                    }).then(function () {
                        resolve();
                    }).catch(function (e) {
                        Util.handleResultError(e, 'Erro ao confirmar');
                    });
                });
            })
            .start();
    }
    
    const getRegexDaysOfMonth = function () {
        return '^(0?[1-9]|[12][0-9]|3[01])$';
    }

    const getRegexIntegerNumbers = function () {
        return '^[0-9]*$';
    }
    
    const configDueDate = function (input, value) {
        switch (value) {
            case BillingDueDateTypeEnum.AFTER_FIXED_DAY:
            default:
                input.inputmask("remove");
                input.inputmask({
                    regex: getRegexDaysOfMonth()
                });
                break;
            case BillingDueDateTypeEnum.AFTER_BILLING_FINAL_DATE:
            case BillingDueDateTypeEnum.AFTER_BILLING_CALCULATION:
            case BillingDueDateTypeEnum.AFTER_BILLING_INITIAL_DATE:
                input.inputmask("remove");
                input.inputmask({
                    regex: getRegexIntegerNumbers()
                });
                break;
        }
    }
    const startDisplayTimer = function (duration, display) {
        var timer = duration - 1;
        var minutes;
        var seconds;

        _displayTimeoutDuration = duration;
        
        if (_displayTimeout !== null) {
            clearInterval(_displayTimeout);
        }
        
        $('#dashboardProgressBar').css('transition-duration', '0s');
        $('#dashboardProgressBar').css('width', '0%');
        $('#dashboardProgressBar').attr('aria-valuenow', '0');

        setTimeout(function () {
            $('#dashboardProgressBar').css('transition-duration', duration + 's');
            $('#dashboardProgressBar').css('width', '100%');
            $('#dashboardProgressBar').attr('aria-valuenow', '100');
        }, 100);

        _displayTimeout = setInterval(function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            $('#dashboardCountdown').html(minutes + ":" + seconds);
            
            if (--timer < 0) {
                clearInterval(_displayTimeout);
            }
        }, 1000);
    };

    const mergeObjectsByProperty = function (array1, array2, prop) {
        let mergedArray = array1.slice();

        array2.forEach(function(obj2) {
            let existingObj = mergedArray.find(function(obj1) {
                return obj1[prop] === obj2[prop];
            });

            if (!existingObj) {
                mergedArray.push(obj2);
            }
        });

        return mergedArray;
    }

    return {
        init: function () {
            init();
        },

        generateQueryStringParam: function (name, value) {
            return generateQueryStringParam(name, value);
        },

        deleteQueryString: function (name) {
            deleteQueryString(name);
        },

        pushQueryString: function (name, value) {
            pushQueryString(name, value);
        },

        readQueryString: function(name) {
            return readQueryString(name);
        },

        generateQueryStringFromObject: function (obj){
            return generateQueryStringFromObject(obj);
        },

        setElementHtml: function (obj, element, index, value) {
            setElementHtml(obj, element, index, value);
        },

        setElementVal: function (obj, element, index, value) {
            setElementVal(obj, element, index, value);
        },

        cloneElement: function(element) {
            return cloneElement(element);
        },

        format: function (param) {
            return format(param);
        },

        textAreaCountUpdate: function (obj) {
            textAreaCountUpdate(obj);
        },

        validateForm: function (f) {
            return validateForm(f);
        },

        select: function (obj, data) {
            return select(obj, data);
        },

        refreshPageRecurrently: function (pageType) {
            refreshPageRecurrently(pageType);
        },

        setRefreshCallback: function (callback) {
            setRefreshCallback(callback);
        },

        stopRefreshPageRecurrently: function () {
            stopRefreshPageRecurrently();
        },

        uuidv4: function() {
            return uuidv4();
        },
        
        showModal: function (modal) {
            showModal(modal);
        },

        closeModal: function (clear) {
            closeModal(clear);
        },

        datetimeMask: function (obj) {
            datetimeMask(obj);
        },

        dateMask: function (obj) {
            dateMask(obj);
        },

        monthMask: function (obj, initialDate) {
            monthMask(obj, initialDate);
        },

        parseString: function(string) {
            return parseString(string);
        },

        parseNumber: function (number) {
            return parseNumber(number);
        },

        parseDecimal: function (number, currencyFormat) {
            return parseDecimal(number, currencyFormat);
        },

        parseBoolean: function (number) {
            return parseBoolean(number);
        },

        parseDate: function (date) {
            return parseDate(date);
        },

        parseDateTime: function(datetime) {
            return parseDateTime(datetime);
        },

        getCurrentUtcDate: function () {
            return getCurrentUtcDate();
        },

        getDateDiff: function (datetime1, datetime2) {
            return getDateDiff(datetime1, datetime2);
        },
        
        setSentryUser: function (data) {
            setSentryUser(data);
        },

        setHeapUniqueIdentifier: function (data) {
            setHeapUniqueIdentifier(data);
        },

        enableInput: function (input, enabled) {
            enableInput(input, enabled);
        },

        refreshPage: function () {
            refreshPage();
        },
        
        isDeveloper: function () {
            return _instance.isDeveloper;
        },
        
        log: function (data) {
            log(data);
        },

        round2: function (num) {
            return round2(num);
        },

        round4: function (num) {
            return round4(num);
        },

        trunc2: function (num) {
            return trunc2(num);
        },

        trunc4: function (num) {
            return trunc4(num);
        },

        trunc: function (num, places) {
            return trunc(num, places);
        },

        handleResultError: function (e, titleAlert) {
            handleResultError(e, titleAlert);
        },
        
        openSupport: function () {
            openSupport();
        },

        removeStringSpaces: function (string) {
            return removeStringSpaces(string);
        },

        showEditableContentPopup: function (data) {
            showEditableContentPopup(data);
        },
        
        configureEditableContents: function (settings) {
            configureEditableContents(settings);
        },

        activateEditableContents: function () {
            activateEditableContents();
        },

        hideSupport: function () {
            hideSupport();
        },
        
        showChat: function () {
            showChat();
        },
        
        hideChat: function () {
            hideChat();
        },
        
        showCalendly: function () {
            showCalendly();
        },
        
        addModalContent: function (url, idDiv) {
            return new Promise( function(resolve, reject){
                addModalContent(url, idDiv);
                resolve();
            });
        },

        removeElementValueWhiteSpaces: function (element) {
            removeElementValueWhiteSpaces(element);
        },

        showProductTour: function (origin) {
            showProductTour(origin);
        },

        showProductTourById: function(productTourId) {
            showProductTourById(productTourId);
        },

        getRegexDaysOfMonth: function () {
            return getRegexDaysOfMonth();
        },

        getRegexIntegerNumbers: function () {
            return getRegexIntegerNumbers();
        },

        configDueDate: function (input, value) {
            configDueDate(input, value)
        },

        startDisplayTimer: function (duration, display) {
            startDisplayTimer(duration, display);
        },

        mergeObjectsByProperty: function (array1, array2, prop) {
            return mergeObjectsByProperty(array1, array2, prop);
        }
    };
}();

jQuery(document).ready(function () {
    Util.init();
});

* 
* */
const Util = new UtilFunctions();
export default Util;
export {MaskTemplateItem, Result};